/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * Run `yarn nx run order:generate-types` and edit the `.graphql` files
 *
 * See codegen config in .graphqlrc.yml for details
 */

/* eslint-disable unicorn/no-abusive-eslint-disable */ /* eslint-disable eslint-comments/no-unlimited-disable */ /* eslint-disable */ /* cspell:disable */

import * as Types from '../../../graphql/types';

import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type InStoreGiftCardsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type InStoreGiftCardsQuery = {
  readonly __typename?: 'Query';
  readonly inStorePaymentMethods: ReadonlyArray<{
    readonly __typename?: 'Credit';
    readonly id: string;
    readonly title: string;
    readonly remainingAmount: number;
  }>;
};

export const InStoreGiftCardsDocument = gql`
  query InStoreGiftCards {
    inStorePaymentMethods {
      id
      title
      remainingAmount
    }
  }
`;

export function useInStoreGiftCardsQuery(
  options?: Omit<Urql.UseQueryArgs<InStoreGiftCardsQueryVariables>, 'query'>,
) {
  return Urql.useQuery<InStoreGiftCardsQuery, InStoreGiftCardsQueryVariables>({
    query: InStoreGiftCardsDocument,
    ...options,
  });
}
